import {
	CustomerOrderOrOfferSalesCommissionView,
	CustomerOrderOrOfferSalesCommissionViewProps,
} from "src/components/views/erp/sales/salesCommissions/orderAndOfferViews/CustomerOrderOfOfferSalesCommissionView.tsx";
import { Permissions } from "src/api/generated/iam/permissions.ts";
import { useHasPermission } from "src/components/views/erp/common/userPermissions.ts";

export interface CustomerOrderSalesCommissionViewProps
	extends Pick<CustomerOrderOrOfferSalesCommissionViewProps, "salesCommissionId" | "salesCommissionViewRefreshRef"> {
	customerOrderId: number;
}

export const CustomerOrderSalesCommissionView = ({
	customerOrderId,
	...other
}: CustomerOrderSalesCommissionViewProps) => {
	const hasPermission = useHasPermission();
	return (
		<CustomerOrderOrOfferSalesCommissionView
			{...other}
			sourceType={"CUSTOMER_ORDER"}
			sourceId={customerOrderId}
			editingEnabled={true}
			hasManageCommissionPermission={hasPermission(Permissions.Sales.CustomerOrderCommissions.MANAGE)}
		/>
	);
};
